module.exports = __webpack_public_path__ + "static/media/Twitter.eb84d2f1.svg";